import { HttpErrorResponse, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AutService } from '../auth/aut.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor(private autService: AutService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const currentUser = this.autService.currentUserValue;
    const isLoggedIn = currentUser && currentUser.token;
    const isApiUrl = req.url.endsWith('aut/loginInvitado');
    let token;
    if (isLoggedIn && !isApiUrl) {
      token = currentUser.token;
    } else {
      token = 'invitado';
    }

    req = req.clone({
      withCredentials: true
    });

    return this.colocarToken( req, next, token );
    // return next.handle(req);
  }

  colocarToken( req: HttpRequest<any>, next: HttpHandler, Token: string ) {
    const headers = new HttpHeaders({
      'x-token': Token
    });

    const reqClone = req.clone({
      headers
    });

    return next.handle( reqClone ).pipe(
      catchError( this.manejarError )
    );
  }

  manejarError( err: HttpErrorResponse ) {
    console.log('Interceptor Error: ', err);
    const { ok, msg } = err.error.ok === undefined ? err : err.error;
    return throwError( { ok, msg } );
  }

}

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
];
